// agriflow/machinerys/static/js/machinerys.js

import machinerysCreate from './module/machinerysCreate';
import machinerysUpdate from './module/machinerysUpdate';
import machinerysChangeHistory from './module/machinerysChangeHistory';

import ArchiveManager from '../../../assets/js/common/ArchiveModal';
import getNextNumerView from '../../../core/static/module/numberRange';
import ActivitiesList from '../../../activities/static/js/module/ActivitiesList';
import checkReferences from '../../../assets/js/common/CheckReferences';
import designationNumber from '../../../assets/js/common/DesignationNumber'; // Todo müll!

document.addEventListener('DOMContentLoaded', function () {
    const machineryscreate = new machinerysCreate();
    const machinerysupdate = new machinerysUpdate();
    const machineryschangehistory = new machinerysChangeHistory();
    
    // Aktivitäten
    if(document.getElementById('activities-machinerys-container')){
        const activitieslist = new ActivitiesList(activitiesList, 'activities-machinerys-container');
        window.reloadActivitiesList = function () {
            if (typeof activitieslist !== 'undefined' && activitieslist) {
                activitieslist.init();
            }
        };
    }

    // Benutzer rechte
    if(document.querySelector('[data-permission="delete_machinerys"]')){
        checkReferences('machinerys', 'Machinerys', machineryId);

        // Archivieren
        const archiveBtn = document.getElementById('archiveBtn');
        if(archiveBtn) {
            const archiveManager = new ArchiveManager(archiveBtn);
            archiveBtn.addEventListener('click', () => {
                const url = archiveBtn.getAttribute('data-archive'); 
                archiveManager.toggleArchive(url)
            });    
        };
    }

    // Bezeichnungsnummer
    designationNumber((form) => {
        getNextNumerView('MAC', 'machineryCreateForm');
    }, 'machineryCreateForm');


}); 